import React from 'react';
import { Typography, Grid, Box } from '@mui/material';
import { COLOR_GREY_600 } from 'src/utils/colors';
import CustomBasicCard from 'src/App/Dashboards/Market/Components/Cards/CustomBasicCard';

interface MetricItem {
  value: string;
  label: string;
  isChip?: boolean;
  chipColor?: string;
  chipTextColor?: string;
}

interface DashboardMetricCardProps {
  title: string;
  icon: React.ReactNode;
  metrics: MetricItem[];
  actionText?: string;
  onActionClick?: () => void;
  timeframe?: string;
}

const DashboardMetricCard: React.FC<DashboardMetricCardProps> = ({
  title,
  icon,
  metrics,
  actionText,
  onActionClick,
  timeframe,
}) => {
  const content = (
    <>
      {metrics.map((metric, index) => (
        <Grid item xs={6} md={4} key={index}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" sx={{ color: COLOR_GREY_600, fontWeight: 500, mb: 1 }}>
              {metric.label}
            </Typography>
            <Typography variant="h2">{metric.value}</Typography>
          </Box>
        </Grid>
      ))}
    </>
  );
  return (
    <CustomBasicCard
      title={title}
      icon={icon}
      content={content}
      actionText={actionText}
      onActionClick={onActionClick}
      headerChip={timeframe}
    />
  );
};

export default DashboardMetricCard;
